<template>
  <div class="ws-info-images">
    <div v-if="value">
      <v-img
        v-for="(image,imageIndex) in value"
        :key="imageIndex"
        :src="image"
      ></v-img>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: null,
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/ws-state-images.scss";
</style>